module.exports = "/_next/static/images/reveal-mask-90ff42cb86db7a6797c0f0cf005b2a27.png";